import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../common/Message";
import Loader from "../common/Loader";
import FormContainer from "../common/FormContainer";
import Meta from "../common/Meta";
import { getUserDetails, updateUser } from "../../actions/userActions";
import { USER_UPDATE_RESET } from "../../constants/userConstants";

const UserEditScreen = () => {
  const { id: userId } = useParams();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [isManager, setIsManager] = useState(false);

  const dispatch = useDispatch();

  const userDetails = useSelector((state) => state.userDetails);
  const { loading, error, user } = userDetails;

  const userUpdate = useSelector((state) => state.userUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = userUpdate;

  const navigate = useNavigate();

  useEffect(() => {
    if (successUpdate) {
      // reset state so the page can be populated with new data
      dispatch({ type: USER_UPDATE_RESET });
      navigate("/admin/userlist");
    } else {
      //if id coming from the url doesnt match user id
      if (!user.firstName || user._id !== userId) {
        dispatch(getUserDetails(userId));
      } else {
        setFirstName(user.firstName);
        setLastName(user.lastName);
        setEmail(user.email);
        setIsAdmin(user.isAdmin);
        setIsManager(user.isManager);
      }
    }
  }, [user, dispatch, userId, successUpdate, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      updateUser({
        _id: userId,
        firstName,
        lastName,
        email,
        isAdmin,
        isManager,
      })
    );
  };

  return (
    <>
      <Meta title="Edit User" />
      <Link to="/admin/userlist" className="btn btn-primary my-3">
        Go Back
      </Link>
      <FormContainer>
        <div className="d-flex justify-content-center">
          <h1>Edit User</h1>
        </div>

        {loadingUpdate && <Loader />}
        {errorUpdate && <Message variant="danger">{errorUpdate}</Message>}
        {loading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="firstName">
              <Form.Label>First name</Form.Label>
              <Form.Control
                type="name"
                placeholder="Enter first name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group controlId="lastName">
              <Form.Label>First name</Form.Label>
              <Form.Control
                type="name"
                placeholder="Enter last name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group controlId="email">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <div className="d-flex justify-content-around">
              <Form.Group controlId="isadmin" className="my-2">
                <Form.Check
                  type="checkbox"
                  label="Is Admin ?"
                  checked={isAdmin}
                  onChange={(e) => setIsAdmin(e.target.checked)}
                ></Form.Check>
              </Form.Group>
              <Form.Group controlId="isManager" className="my-2">
                <Form.Check
                  type="checkbox"
                  label="Is Manager ?"
                  checked={isManager}
                  onChange={(e) => setIsManager(e.target.checked)}
                ></Form.Check>
              </Form.Group>
            </div>

            <div className="d-flex justify-content-center">
              <Button type="submit" variant="primary">
                Update
              </Button>
            </div>
          </Form>
        )}
      </FormContainer>
    </>
  );
};

export default UserEditScreen;
